module.exports = window.__federationLoadRemote("moduleUpptic");